import * as React from 'react';

export default function ActionAreaCard({ icon, heading, subheading, top, content }) {
  if (top) {
    return (
      <div className="w-full">
        <div className="flex flex-col sm:flex-row h-auto sm:h-24 rounded-xl gap-2 justify-center items-center shadow-lg bg-[#c0f0e2] opacity-90 p-4 sm:p-2 transition-shadow hover:shadow-xl">
          <div className="bg-skin-button flex justify-center items-center p-3 sm:p-5 rounded-full">
            <div className="text-xl sm:text-2xl text-white">{icon}</div>
          </div>
          <div className="flex flex-1 flex-col justify-center text-center sm:text-left items-center">
            <h3 className="text-sm sm:text-base font-medium text-gray-800 line-clamp-2">
              {heading}
            </h3>
            <p className="text-base sm:text-lg text-[#42A5F5] font-semibold mt-1">
              {subheading}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex flex-col sm:flex-row h-auto rounded-xl gap-2 justify-center shadow-lg bg-[#c0f0e2] opacity-90 hover:shadow-2xl transition-shadow p-4 sm:p-2">
        <div className="bg-skin-button flex justify-center items-center p-3 rounded-full">
          <div className="text-xl sm:text-2xl text-white ">{icon}</div>
        </div>
        <div className="flex flex-1 flex-col justify-center text-center sm:text-left items-center">
          <h3 className="text-sm sm:text-base font-medium text-gray-800 line-clamp-2">
            {heading}
          </h3>
          <p className="text-base sm:text-lg text-[#42A5F5] font-semibold mt-1">
            {content}
          </p>
        </div>
      </div>
    </div>
  );
}
